import React from 'react';
export const MainHeadline = () => {
  return <section className="mb-12" data-id="element-162">
      <h1 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 text-center" style={{
      fontFamily: "'DM Sans', sans-serif"
    }} data-id="element-163">
        Why Your Dermatologist Won't Tell You About This £59 Anti-Aging
        Breakthrough
      </h1>
      <div className="relative mb-8" data-id="element-164">
        <div className="bg-blue-50 p-4 rounded-lg" data-id="element-165">
          <p className="text-lg text-gray-700 italic" data-id="element-166">
            The simple solution that could slash your spending on expensive
            aging treatments... and why the beauty industry desperately wants to
            keep it secret.
          </p>
        </div>
        <div className="absolute md:block hidden" style={{
        right: '-200px',
        top: '-5px'
      }} data-id="element-167">
          <span className="block text-gray-600 mb-1 pb-1 border-b border-gray-300" style={{
          width: '180px'
        }} data-id="element-168">
            Featured
          </span>
          <a href="https://offer.getveloura.co.uk/" target="_blank" rel="noopener noreferrer" data-id="element-169">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/h7FgNXB8uRTHF3duaHeAAE/sideimgadv.png" alt="Veloura silk pillowcase product" className="max-w-[180px] h-auto cursor-pointer hover:opacity-90 transition-opacity" data-id="element-170" />
          </a>
        </div>
      </div>
      <div className="w-full flex justify-center mb-8" data-id="element-171">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6RRyDsVtojYyBKjrzkE55p/20250626_1140_Dusty_Pillow_Close-up_remix_01jynx245rf90rrbx9q7ygp7aw.png" alt="Microscopic view of bacteria and dust mites on a cotton pillowcase" className="rounded-lg shadow-lg max-w-full md:max-w-2xl" data-id="element-172" />
      </div>
    </section>;
};